import { useEffect, useState } from 'react';
import { paddClient as padd } from '@plangrid-private/web-api-clients';

const fetchAllPublishedTemplates = async (accountId, syncToken) => {
  const {
    pagination: { nextUrl },
    results,
  } = await padd.listAccountTemplates(accountId, {
    'filter[isPublished]': [true],
    syncToken,
  });
  return nextUrl
    ? results.concat(
        await fetchAllPublishedTemplates(
          accountId,
          new URLSearchParams(nextUrl).get('syncToken')
        )
      )
    : results;
};

const paddClient = {
  fetchPublishedTemplates: async (accountId) => {
    const data = await fetchAllPublishedTemplates(accountId);
    return data;
  },
};

export const usePublishedTemplates = (account) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [templates, setTemplates] = useState([]);

  useEffect(() => {
    if (account) {
      setLoading(true);
      paddClient
        .fetchPublishedTemplates(account.id)
        .then((fetchedTemplates) =>
          setTemplates(
            fetchedTemplates.map(({ templateId, name, isPublished }) => ({
              id: templateId,
              name,
              isPublished,
            }))
          )
        )
        .catch(() => setError(true))
        .finally(() => setLoading(false));
    }
  }, [account]);

  return {
    loading,
    error,
    templates,
  };
};
